import { private_server } from '../../utils/axios';
import { USER_TYPES } from '../../utils/enums';
import { onGetUserTypeFromToken } from '../../utils/general';


const usePatientData = () => {   

    const actions = {
        // Get list of all users
        onGet: async(idpatientdata) => {

            const userType = onGetUserTypeFromToken()
            let request

            let result = null
            if(userType === USER_TYPES.ADMIN){
                request = await private_server.get(`/patientdata/${idpatientdata}`)
            }else{
                request = await private_server.get(`/patientdata/${idpatientdata}/client`)
            }
            
            result = request.data.data.patient_data
            return result
        },
        onGetMe: async() => {
            let result = null
            const request = await private_server.get(`/patientdata/me`)
            result = request.data.data.patient_data
            return result
        },
        onEdit: async(idpatientdata, data2send) => {
            const userType = onGetUserTypeFromToken()
            if(userType === USER_TYPES.ADMIN){
                await private_server.patch(`/patientdata/${idpatientdata}`, data2send)
            }else{
                await private_server.patch(`/patientdata/${idpatientdata}/client`, data2send)
            }
            
        },

    }

    return {
        actions
    }
}
 
export default usePatientData;